export { default } from "./AdminConsoleSchoolGeneralInformationForm";
